import {
  BrandFragment,
  BrandWithProductsFragment,
  MiniBrandFragment,
} from "../../gql/hooks";

export const OtherBrands = ["MULTIMARCA", "OTHER", "OTRAS"];

export type wideBrandType =
  | MiniBrandFragment
  | BrandFragment
  | BrandWithProductsFragment;

export const sortBrands = (
  brands:
    | BrandFragment[]
    | MiniBrandFragment[]
    | BrandWithProductsFragment[]
    | [] = [],
  selected?:
    | BrandFragment
    | MiniBrandFragment
    | BrandWithProductsFragment
    | string,
  brandsToUse: string[] = [],
  isMainBrand: boolean = true,
) => {
  if (!brands?.length) return brands || [];

  let sortedBrands = isMainBrand
    ? (brands as wideBrandType[]).filter((_: wideBrandType) => !!_.isMainBrand)
    : brands;

  if (brandsToUse.length) {
    sortedBrands = sortedBrands.filter(({ name }: wideBrandType) =>
      brandsToUse.includes(name),
    );
  }

  sortedBrands = [...sortedBrands].sort((brandA, brandB) => {
    const brandAIndex = brandA.order;
    const brandBIndex = brandB.order;

    if (brandAIndex < 0) return 1;
    if (brandBIndex < 0) return -1;
    return brandAIndex - brandBIndex;
  });

  if (selected) {
    sortedBrands = sortedBrands.sort((a: wideBrandType, b: wideBrandType) => {
      if (typeof selected === "string") {
        if (a.name === selected) return -1;
        if (b.name === selected) return 1;
      } else {
        if (a.id === selected.id) return -1;
        if (b.id === selected.id) return 1;
      }
      return 0;
    });
  }
  return sortedBrands;
};

export const sortByBrand = (brandA: wideBrandType, brandB: wideBrandType) => {
  const brandAIndex = brandA.order;
  const brandBIndex = brandB.order;

  if (brandAIndex < 0) return 1;
  if (brandBIndex < 0) return -1;
  return brandAIndex - brandBIndex;
};
